<template>
  <section class="product-traffic">
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <b-field>
          <p class="control">
            <a
              :href="helpImageUrl('交通說明.png')"
              @click.prevent="onClickImage(helpImageUrl('交通說明.png'))"
              style="margin-left: 1rem;"
            >
              <img
                :src="helpImageUrl('交通說明.png')"
                alt="交通說明"
                width="56"
              />
            </a>
          </p>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            style="width: 240px; position: absolute; top: 10px; right: 10px;"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>

        <editor
          ref="air_line_desc_editor"
          v-model="form.air_line_desc"
          :area="product.image_path"
          :height="editorHeight"
        ></editor>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'

export default {
  name: 'TrafficForm',
  components: { Editor },

  props: {
    product: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      product_code: this.product.code,
      form: this.extractFormValues(this.product),

      isImageModalActive: false,
      selectedImageUrl: null,

      windowHeight: window.innerHeight
    }
  },
  computed: {
    editorHeight() {
      return this.windowHeight - 350
    }
  },
  validations: {
    form: {
      air_line_desc: {}
    }
  },
  watch: {
    product(newProduct) {
      this.product_code = newProduct.code
      this.form = this.extractFormValues(newProduct)
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    extractFormValues(data) {
      return {
        air_line_desc: data.air_line_desc || ''
      }
    },
    async onSend() {
      this.form.air_line_desc = this.$refs.air_line_desc_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${PRODUCTS_API}/${this.product_code}/traffic`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)
        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    onResize() {
      this.windowHeight = window.innerHeight
    }
  }
}
</script>
